import React, { useEffect, useRef, useState } from 'react';
import { Clip } from '../data/teaser';
import { usePaused } from '../hooks/usePlayback';
interface ClipStageProps {
  clip: Clip;
  /** Tailwind height class for the stage. */
  heightClass?: string;
  /** Milliseconds per frame when playing the frame sequence. */
  frameMs?: number;
}

/**
 * Short clinical clip. Plays real footage when a video source is supplied,
 * otherwise runs the frames as a smoothly looping 2–4 second sequence.
 */
export function ClipStage({
  clip,
  heightClass = 'h-56',
  frameMs = 1000
}: ClipStageProps) {
  const [frame, setFrame] = useState(0);
  const paused = usePaused();
  const videoRef = useRef<HTMLVideoElement | null>(null);
  useEffect(() => {
    if (clip.video || clip.frames.length < 2 || paused) return;
    const interval = setInterval(() => {
      setFrame(prev => (prev + 1) % clip.frames.length);
    }, frameMs);
    return () => clearInterval(interval);
  }, [clip, frameMs, paused]);
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    if (paused) {
      video.pause();
    } else {
      void video.play().catch(() => undefined);
    }
  }, [paused]);
  return <div className={`relative w-full overflow-hidden rounded-2xl border border-white/10 bg-black/30 ${heightClass}`} data-id="element-40" data-mp="3dtftoi7a68cs">
      {clip.video ? <video ref={videoRef} src={clip.video} autoPlay muted loop playsInline aria-label={clip.alt} className="h-full w-full object-cover" data-id="element-41" data-mp="3iqz8pkbsyp5s" /> : clip.frames.map((src, index) => <img key={src} src={src} alt={index === 0 ? clip.alt : ''} aria-hidden={index !== 0} className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-500 ${index === frame ? 'opacity-100' : 'opacity-0'}`} style={{
      transform: index === frame ? 'scale(1)' : 'scale(1.06)',
      transition: 'opacity 500ms ease-out, transform 1600ms ease-out'
    }} data-id="element-42" data-mp="2v49a6synxcpx" data-mpi={index} />)}

      {clip.frames.length > 1 && !clip.video && <div className="absolute bottom-3 left-3 flex gap-1.5" aria-hidden="true" data-id="element-43" data-mp="1xai2x8pq3dkn">
          {clip.frames.map((src, index) => <span key={src} className={`h-1 rounded-full transition-all duration-300 ${index === frame ? 'w-5 bg-solventum-primary' : 'w-2 bg-white/30'}`} data-id="element-44" data-mp="1sc6tv079573h" data-mpi={index} />)}
        </div>}
    </div>;
}